module.exports = __webpack_public_path__ + "img/MFT白皮书_28.578c44f7.jpg";